import { normalizeApiError } from '../api/apiError';

const CODE_MESSAGES: Record<string, string> = {
  PROJECT_NOT_FOUND: 'The requested project could not be found.',
  PROJECT_MEMBER_NOT_FOUND: 'Assigned employee must be a member of this project.',
  PROJECT_COLUMN_NOT_FOUND: 'That project column could not be found.',
  PROJECT_MEMBER_FAILED: 'The project member could not be saved.',
  PROJECT_MEMBER_NOT_IN_TEAM: 'You can only assign employees from your team.',
  PROJECT_COLUMN_FAILED: 'The project column could not be saved.',
  TASK_NOT_FOUND: 'The requested task could not be found.',
  TASK_LIMIT_REACHED: 'This column has reached its task limit.',
  TASK_DETAILS_REQUIRED: 'Complete the required task information for this column.',
  TASK_MOVE_BLOCKED: 'This task cannot be moved until the required fields are completed.',
  COMPLETED_DATE_REQUIRED: 'Select the date this task was completed.',
  TASK_CREATE_FAILED: 'The task could not be saved.',
  PROJECT_REPORT_NOT_INSTALLED:
    'The project task report is not set up on the server yet. Contact your administrator.',
  REPORT_TOO_LARGE:
    'The report is too large. Narrow the date range or select an employee.',
  EMPLOYEE_PROFILE_REQUIRED:
    'Your login is not linked to an employee profile. Contact your HR administrator.',
  TIME_LOG_EMPLOYEE_REQUIRED: 'Select the employee this time entry is for.',
  TIME_LOG_EMPLOYEE_NOT_ALLOWED:
    'You can only log time for yourself or an employee assigned to this task.',
  TIME_LOG_NOT_PROJECT_MEMBER: 'Time can only be logged for active members of this project.',
  TIME_LOG_NOT_OWNED: 'You can only delete your own time entries.',
  TIME_LOG_NOT_FOUND: 'That time entry could not be found.',
};

export function projectErrorMessage(
  error: unknown,
  fallback = 'Unable to save the project.',
): string {
  const apiError = normalizeApiError(error);
  if (apiError.code && CODE_MESSAGES[apiError.code]) {
    return CODE_MESSAGES[apiError.code];
  }
  return apiError.message || fallback;
}
